export const TypeSummaryAmountField = Object.freeze({
  PAY: 'payAmount',
  BILL: 'billAmount'
})

export const getTypeSummaryAmount = (row, timeTypeId, amountField) => {
  if (amountField !== TypeSummaryAmountField.PAY && amountField !== TypeSummaryAmountField.BILL) {
    throw new Error(`getTypeSummaryAmount: unknown amountField "${amountField}"`)
  }
  const match = (row.typeSummaries || []).find(typeSummary => typeSummary.timeTypeId === timeTypeId)
  return match ? match[amountField] : 0
}

export default getTypeSummaryAmount
